import { useCallback, useEffect, useState } from "react";
import {
  CANCELLED,
  COMPLETED,
  EMAIL_REGEX,
  FAILED,
  FREE_SEAT,
  OFFLINE_COMPLETED,
  OFFLINE_PENDING,
  ON_HOLD,
  ONLINE_COMPLETED,
  PAYMENT_REQUEST,
  ONLINE_PENDING,
  PENDING,
  PENDING_APPROVAL,
  PROGRAM_CARD_MSG,
  REJECTED,
  SAVE_DRAFT,
  SECTION_KEYS,
  stateGstCodes,
  SUCCESS,
  TRAVEL_PENDING,
  WAIT_LIST,
  WARNING_MESSAGES,
  REQUESTED,
  BLESS_REJECTED,
  AMOUNT_TO_BE_PAID,
} from "../constants";
import { endPoints } from "../constants/urlConstants";
import {
  DateValidation,
  FormResponse,
  Program,
  ProgramDetails,
  ProgramQuestionMap,
  Question,
} from "../pages/Registration";
// import { getCall } from "../services/apiService";
import { getCall, postCall } from "../services/apiService";
import dayjs from "dayjs";
import axios from "axios";
import { RegistrationStatus } from "../types/registration";
import { calCulatePercentage, formatIndianCurrency, hasApprovedStatusOptimized } from "./commonFunctions";
import { isValidPhoneNumber } from "libphonenumber-js";
// const s3 = new S3Client({
//   region: process.env.REACT_APP_AWS_REGION, // 'ap-south-1',
//   credentials: {
//     accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || "", // 'AKIATOWWTX6I3DL2PYXJ',      // ⚠️ Avoid hardcoding in real apps
//     secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY || "", //'xBO1LykVgxozKVqXXxfZX9i661C/1PTU00lGCJ+q',  // ⚠️ Use Cognito or env variables
//   },
// });
export interface ProgramRegistration {
  id: string;
  program: {
    id: number;
    name: string;
    requiresApproval?: boolean;
    requiresPayment?: boolean;
    involvesTravel?: boolean; // can be removed
    isTravelInvolved?: boolean;
    noOfSession?: number;
    limitedSeats?: boolean;
    isGroupedProgram?: boolean; // For grouped programss
  };
  userId: string | null;
  fullName: string;
  programRegistrationSeqNumber?: string | null;
  waitingListSeqNumber?: string | null;
  mobileNumber: string;
  emailAddress: string;
  registrationStatus: string;
  basicDetailsStatus: string;
  invoiceDetails?: any[];
  paymentDetails?: any[];
  approvals?: any[];
  travelInfo?: any[];
  travelPlans?: any[];
  registrationDate: string | null;
  allocatedProgram?: Program | null; // For grouped programs
  isFreeSeat?: boolean; // For free seats
  programSession?: Program | null; // For programs with multiple sessions
}

export interface userRegistration {
  id: string;
  program: {
    id: number;
    name: string;
    requiresApproval?: boolean;
    requiresPayment?: boolean;
    involvesTravel?: boolean; // can be removed
    isTravelInvolved?: boolean;
    noOfSession?: number;
    limitedSeats?: boolean;
    isGroupedProgram?: boolean; // For grouped programss
  };
  fullName: string;
  userId?: string | null;
  registrationSeqNumber?: string | null;
  programRegistrationSeqNumber?: string | null;
  waitingListSeqNumber?: string | null;
  mobileNumber: string;
  emailAddress: string;
  registrationStatus: string;
  basicDetailsStatus: string;
  registrationDate: string | null;
  isFreeSeat?: boolean; // For free seats
  travelInfo: any[];
  travelPlans: any[];
  invoiceDetails: any[];
  paymentDetails: any[];
  approvals?: any[];
  allocatedProgram?: Program | null; // For grouped programs
  programSession?: Program | null; // For programs with multiple sessions
}

interface RegistrationQuestion {
  questionId: number;
  questionLabel: string;
  sectionId: number;
  sectionName: string;
  answer: string;
}

export interface GroupedQuestion {
  // questionId: number;
  // questionLabel: string;
  // sectionName: string;
  // answer: string;
  [key: number]: string; // Dynamic keys for questionId and answer
}
export const createBindingKeyMap = (userData, questions) => {
  const bindingMap = {};

  questions.forEach((pqm) => {
    const bindingKey = pqm.question.bindingKey;
    if (bindingKey && userData[bindingKey] !== undefined) {
      bindingMap[pqm.question.id] = {
        value: userData[bindingKey],
        bindingKey,
        hasExistingData:
          userData[bindingKey] !== null && userData[bindingKey] !== "",
      };
    }
  });

  return bindingMap;
};

export const fetchRegistrationStatus = async (
  endPoint: string,
  setData: (data: any) => void,
  programId?: any,
) => {
  getCall(endPoint, undefined, false)
    .then((response) => {
      if (response.status === 200) {
        if (programId === undefined || programId === null) {
          setData(response.data.data.data);
        } else {
          const details = getProgramDetails(programId, response.data.data.data);
          setData(details);
        }
      } else {
        setData({});
      }
    })
    .catch((error) => {
      console.error("Error fetching registration status:", error);
      setData({});
    });
  return null; // Default return if no data is fetched
};

export const getProgramRegistration = (
  programId: number,
  registrations: ProgramRegistration[],
): ProgramRegistration | undefined => {
  // const registration = registrations.find(reg => reg.program.id === programId);
  return registrations.find(
    (reg) => reg.program.id == programId && reg.userId != null,
  );
};

// Example usage with type checking
const getProgramDetails = (
  programId: number,
  registrations: ProgramRegistration[],
): userRegistration | null => {
  const registration = getProgramRegistration(programId, registrations);

  if (!registration) {
    return null;
  }

  return {
    id: registration.id,
    program: registration.program,
    fullName: registration.fullName,
    programRegistrationSeqNumber:
      registration.programRegistrationSeqNumber || null,
    waitingListSeqNumber: registration.waitingListSeqNumber || null,
    mobileNumber: registration.mobileNumber,
    emailAddress: registration.emailAddress,
    registrationStatus: registration.registrationStatus,
    basicDetailsStatus: registration.basicDetailsStatus,
    registrationDate: registration.registrationDate,
    travelInfo: registration.travelInfo || [],
    approvals: registration.approvals || [],
    travelPlans: registration.travelPlans || [],
    isFreeSeat: registration.isFreeSeat || false,
    invoiceDetails: registration.invoiceDetails || [],
    paymentDetails: registration.paymentDetails || [],
    allocatedProgram: registration.allocatedProgram || null, // For grouped programs
    programSession: registration.programSession || null, // For programs with multiple sessions
  };
};

export const getFormStatus = (
  userStatus: userRegistration | null,
  programDetails: ProgramDetails | null,
  showAdditionalInfo: boolean,
  editRegistration: boolean,
): boolean => {
  if (
    (userStatus?.registrationStatus === "pending" && !( userStatus?.approvals && userStatus?.approvals?.length > 0  && userStatus?.approvals[0]?.approvalStatus === ON_HOLD))||
    userStatus?.registrationStatus == null ||
    userStatus?.registrationStatus == undefined ||
    userStatus?.registrationStatus === "draft" ||
    userStatus?.registrationStatus === SAVE_DRAFT
  ) {
    return true;
  } else if (
    (userStatus?.registrationStatus === "completed" &&
      programDetails?.type.involvesTravel &&
      userStatus?.travelInfo.length === 0 &&
      showAdditionalInfo) ||
    (userStatus?.registrationStatus === "pending" && !( userStatus?.approvals && userStatus?.approvals?.length > 0  && userStatus?.approvals[0]?.approvalStatus === ON_HOLD))
  ) {
    return true;
  } else if (
    (userStatus?.registrationStatus === PENDING_APPROVAL ||
      // userStatus?.registrationStatus === WAIT_LIST ||
      userStatus?.registrationStatus === ON_HOLD ||
      (userStatus?.approvals &&
        userStatus?.approvals.length > 0 &&
        userStatus?.approvals[0]?.approvalStatus == ON_HOLD) ||
      userStatus?.registrationStatus === REJECTED) &&
    editRegistration
  ) {
    return true;
  } else if (userStatus?.paymentDetails[0]?.paymentStatus == OFFLINE_PENDING && userStatus?.paymentDetails?.[0]?.editRequests?.[0]?.requestStatus == REQUESTED){
    return true;
  }
  return false;
};

export const sectionConstants = {
  invoiceDetails: "Invoice", //2
  travelInfo: "Travel Plan & Goodies", //3
};

export const fetchProgramsData = async (userId: string) => {
  try {
    const [programsResponse, registrationsResponse] = await Promise.all([
      getCall(
        endPoints.getProgramEndPoint({
          status: "published",
          // programKey: "PT_ENTRAINMENT",
        }),
        undefined,
        false,
      ), // list of published programs
      getCall(`user/${userId}/registrations?limit=10`, undefined, false), //list of registrations for the user
    ]);

    return {
      programs: programsResponse.data.data.data,
      registrations: registrationsResponse.data.data.data,
      featureFlags: programsResponse.data.data.featureFlags,
    };
  } catch (error) {
    throw new Error("Failed to fetch program data");
  }
};

export const getStatusOfProgram = (
  programs: ProgramDetails[],
  registrations: userRegistration[],
) => {
  const programStatusMap: ProgramDetails[] = [];

  programs.map((program: ProgramDetails) => {
    const registration = registrations.find(
      (reg) => reg?.program?.id === program?.id && reg?.userId != null,
    );
    console.log("registration status of the program", registration?.id);
    console.log("registration status of the program abc", registration);
    const travelInfo = registration?.travelInfo || [];
    programStatusMap.push({
      ...program,
      registrationId: registration?.id || null,
      blessesProgram: program.isGroupedProgram
        ? registration?.allocatedProgram
        : program?.noOfSession
          ? registration?.programSession
          : null,
      isFreeSeat: registration?.isFreeSeat || false,
      statusMessage: registration
        ? getStatusMessage(program, registration)
        : undefined,

      travelInfo: travelInfo,
    });
  });
  return programStatusMap;
};

const getStatusMessage = (
  program: ProgramDetails,
  registration: userRegistration,
): object => {
  var allocatedProgram = "";
  var allocatedProgramStartsAt = "";
  var allocatedProgramEndsAt = "";
  if (program.isGroupedProgram) {
    allocatedProgram = registration?.allocatedProgram?.name || "";
    allocatedProgramStartsAt = registration?.allocatedProgram?.startsAt || "";
    allocatedProgramEndsAt = registration?.allocatedProgram?.endsAt || "";
  } else if (program?.noOfSession > 0) {
    allocatedProgram = registration?.programSession?.name || "";
    allocatedProgramStartsAt = registration?.programSession?.startsAt || "";
    allocatedProgramEndsAt = registration?.programSession?.endsAt || "";
  } else {
    allocatedProgram = program.name;
    allocatedProgramStartsAt = program.startsAt || "";
    allocatedProgramEndsAt = program.endsAt || "";
  }
  if (registration.registrationStatus === CANCELLED) {
    return {
      message: WARNING_MESSAGES.REG_CANCELLED,
      state: CANCELLED,
    };
  } 
  else if (registration.registrationStatus === SAVE_DRAFT) {
    return {
      message: [""],
      state: SAVE_DRAFT,
    };
  } else if (registration.registrationStatus === PENDING_APPROVAL) {
    return {
      message: PROGRAM_CARD_MSG.PENDING_APPROVAL,
      state: PENDING_APPROVAL,
    };
  } else if (
    registration?.approvals &&
    registration?.approvals.length > 0 &&
    registration?.approvals[0]?.approvalStatus == ON_HOLD
  ) {
    return {
      message: PROGRAM_CARD_MSG.ON_HOLD,
      state: ON_HOLD,
    };
  } else if (registration.registrationStatus === REJECTED) {
    // Treating REJECTED same as ON_HOLD for the seeker
    if(registration?.approvals &&
      registration?.approvals.length > 0 && hasApprovedStatusOptimized(registration?.approvals[0]?.tracks)){
      return {
      message:  ["You were offered a sacred seat in (HDB/MSD) by Mahatria. Based on your request, your seat is on HOLD."],
      state: BLESS_REJECTED,
      }
    } else{
    return {
      message: PROGRAM_CARD_MSG.REJECTED,
      state: REJECTED,
    };
  }
}
 else if (
    program.limitedSeats &&
    registration.registrationStatus === WAIT_LIST
  ) {
    // return "Registered to program and seat is waiting list";
    return {
      message: [
        `You’ve been registered for ${program.name}.`,
        "We’ll be in touch with the next steps and all the details soon.",
      ],
      state: PENDING_APPROVAL,
    };
  } else if (
    registration?.program.requiresPayment &&
    registration?.paymentDetails.length === 0 
    &&
    !registration.isFreeSeat 
  ) {
    // return "Registered to program and payment pending";
    return {
      message: [
        // `Your participation in ${allocatedProgram} is now approved by Mahatria.`,
        // "To move ahead, please click the Make Payment button below. You can also download your Pro-forma Invoice for reference.",
        `${allocatedProgram} - ${formatDateWithDay(allocatedProgramStartsAt)} to ${formatDateWithDay(allocatedProgramEndsAt)}`,
        "Please complete your payment",
        `Click here to download 'Pro-forma Invoice'`,
      ],
      state: PENDING,
    };
  } else if (
    registration?.program.requiresPayment &&
    registration?.paymentDetails.length > 0 &&
    !registration?.isFreeSeat 
  ) {
    if ((registration?.paymentDetails[0]?.paymentStatus == ONLINE_PENDING) || (registration?.paymentDetails[0]?.paymentStatus == FAILED)) {
      // return "Registered to program and online payment pending";
      return {
        message: [
          `Your participation in ${allocatedProgram} is now approved by Mahatria.`,
          "To move ahead, please click the Make Payment button below. Click here to download 'Pro-forma Invoice",
        ],
        state: PENDING,
      };

    } 
    else if (
      registration?.paymentDetails[0]?.paymentStatus == OFFLINE_PENDING && registration?.paymentDetails?.[0]?.editRequests?.[0]?.requestStatus==REQUESTED
    )
     {
      return {
        message: [
          `We acknowledge your payment towards ${allocatedProgram} - ${formatDateWithDay(allocatedProgramStartsAt)} to ${formatDateWithDay(allocatedProgramEndsAt)}.`,
           registration?.paymentDetails[0]?.offlineMeta?.paymentMode == "Cheque" ?  "Note: Cheques are subject to realization" : "",
        ],
        state: PAYMENT_REQUEST,
      };
    }else if (
      registration?.paymentDetails[0]?.paymentStatus == OFFLINE_PENDING &&
      registration?.registrationStatus == COMPLETED
    ) {
      // return "Registered to program and offline payment pending";
      
      return {
        message: [
          `Your payment for ${allocatedProgram} is successfully recorded.`,
          "We will update your status as soon as payment is completed.",
        ],
        state: COMPLETED,
      };
    }
    else if (
      registration?.paymentDetails[0]?.paymentStatus == OFFLINE_PENDING &&
      registration?.registrationStatus == PENDING
    ) {
      // return "Registered to program and offline payment pending";
      
      return {
        message: [
          `We acknowledge your payment towards ${allocatedProgram} - ${formatDateWithDay(allocatedProgramStartsAt)} to ${formatDateWithDay(allocatedProgramEndsAt)}.`,
          registration?.paymentDetails[0]?.offlineMeta?.paymentMode == "Cheque" ?  "Note: Cheques are subject to realization" : "",
           `Click the 'summary' button to view your complete registration details anytime`,
        ],
        state: COMPLETED,
      };
    }
    
    // else if (
    //   registration?.paymentDetails[0]?.paymentStatus == OFFLINE_PENDING
    // ) {
    //   // return "Registered to program and offline payment pending";
    //   return {
    //     message: [
    //       // `Your payment for ${allocatedProgram} is successfully recorded.`,
    //       // "To proceed, please share your travel plan below. We will update your status as soon as payment is completed.",
    //       `We acknowledge your payment towards ${allocatedProgram} - ${formatDateWithDay(allocatedProgramStartsAt)} to ${formatDateWithDay(allocatedProgramEndsAt)}`,
    //       "Note: Cheques are subject to realization",
    //       "Please update your travel plan"
    //     ],
    //     state: TRAVEL_PENDING,
    //   };
    // }
    // else if (
    //   registration?.paymentDetails[0]?.paymentStatus?.includes("completed") &&
    //   registration?.registrationStatus == PENDING
    // ) {
    //   // return "Registered to program and payment completed";
    //   return {
    //     message: [
    //       // `Your payment for ${allocatedProgram} is successfully recorded.`,
    //       // "To proceed, please share your travel plan below. You may also download your invoice.",
    //       `Payment towards ${formatDateWithDay(allocatedProgramStartsAt)} to ${formatDateWithDay(allocatedProgramEndsAt)} is successful.`,
    //       `Click here to download 'Tax invoice'`,
    //       `Please update your travel plan`
    //     ],
    //     state: TRAVEL_PENDING,
    //   };
    // }
  }
  else if(registration.isFreeSeat){
    return {
      message: PROGRAM_CARD_MSG.FREE_SEAT,
      state: COMPLETED,
    };
  }

  if(registration.paymentDetails[0]?.paymentStatus === "online_completed")
  {
    return {
      message: [
        `Payment towards ${allocatedProgram} - ${formatDateWithDay(allocatedProgramStartsAt)} to ${formatDateWithDay(allocatedProgramEndsAt)} is successful.`,
         `Click here to download 'Tax Invoice'`,
        `Click the 'summary' button to view your complete registration details anytime`,
      ],
      state: COMPLETED,
    }
  }

  if(registration.paymentDetails[0]?.paymentStatus === "offline_completed")
  {
    return {
      message: [
        `Payment towards ${allocatedProgram} - ${formatDateWithDay(allocatedProgramStartsAt)} to ${formatDateWithDay(allocatedProgramEndsAt)} is successful.`,
        `Click here to download 'Tax Invoice'`,
        `Click the 'summary' button to view your complete registration details anytime`,
      ],
      state: COMPLETED,
    }
  }
 


  // else if (
  //   registration?.program.isTravelInvolved &&
  //   registration?.travelInfo.length === 0
  // ) {
  //   // return "Registered to program and travel details pending";
  //   return {
  //     message: [
  //       `Your payment for ${allocatedProgram} is successfully recorded.`,
  //       "To proceed, please share your travel plan below. You may also download your invoice.",
  //     ],
  //     state: TRAVEL_PENDING,
  //   };
  // }

  return {
    message: [
      "Your seat is confirmed, your invoice has been linked.",
      "Click the Summary button to view your complete registration details anytime.",
      registration?.paymentDetails[0]?.paymentStatus != OFFLINE_PENDING ? "Click here to download 'Tax invoice'": "The invoice will be generated after acknowledgment of your payment.",
    ],
    state: COMPLETED,
  };
};
export function formatDateWithDay(dateString: string) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const weekday = date.toLocaleDateString("en-GB", { weekday: "long" });
  return `${day} ${month} ${year} (${weekday})`;
}

export const handleAWSFileUpload = async (
  file: File,
  setAlert?: (alert: {
    open: boolean;
    message: string[];
    type: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    confirmText?: string;
    cancelText?: string;
  }) => void,
): Promise<string | null> => {
  try {
    const payload = {
      fileName: file.name,
      contentType: file.type,
    };
    const fileUrls = await postCall(endPoints.fileUpload, payload, false);
    if (fileUrls?.data?.data?.accessUrl && fileUrls?.data?.data?.putUrl) {
      const blob = await convertFileToBlob(file);
      await axios.put(fileUrls.data.data.putUrl, blob);
      return fileUrls.data.data.accessUrl;
    } else {
       setAlert?.({
        open: true,
        message: WARNING_MESSAGES.API_ERROR,
        type: "warning",
        confirmText: "retry",
       cancelText: "cancel",
      });
      return null;
    }
  } catch (error) {
    setAlert?.({
        open: true,
        message: WARNING_MESSAGES.API_ERROR,
        type: "warning",
        confirmText: "retry",
       cancelText: "cancel",
      });
    return null;
  }
};

const convertFileToBlob = async (file: File) => {
  const arrayBuffer = await file.arrayBuffer();
  const blob = new Blob([arrayBuffer], { type: file.type });
  return blob;
};

export const formatDateToWeekDate = (date: string): string => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [year, month, day] = date.split("-").map(Number);
  const monthName = months[month - 1];

  return `${monthName} ${day}, ${year}`;
};

export const validateCurrentSection = async (
  currentSectionIndex: number,
  groupedQuestions: {
    [key: number]: {
      section: any;
      hasData: ProgramQuestionMap[];
      needData: ProgramQuestionMap[];
      questions: ProgramQuestionMap[];
      subSection?: ProgramQuestionMap[];
    };
  } | null,
  setErrors: any,
  formData: FormResponse,
  allocatedProgram: Program | null,
  bindingKeyHashMap: { [key: string]: number } | null,
): boolean => {
  // const groupedQuestions = getGroupedQuestions();
  console.log("Validating current section", formData);
  try {
    if (!groupedQuestions) return false;
    const sections = Object.values(groupedQuestions);
    const currentSection = sections[currentSectionIndex - 1];

    if (!currentSection) return true;
    const newErrors: { [key: string]: { message: string, displayOrder: number, sectionOrder: number } } = {};
    let isValid = true;
    await Promise.all(
      currentSection.hasData.map(async (pqm) => {
        // if(formData[currentSectionIndex] && formData[currentSectionIndex][pqm.question.id]) {
        const sectionData = formData[currentSectionIndex];
        if (!sectionData) {
         newErrors[pqm.question.id] = {
        message: "required",
        displayOrder: pqm.displayOrder ?? 0,
        sectionOrder: pqm.programQuestionFormSection?.displayOrder ?? 0,
      };
          isValid = false;
        } else {
          const error = await validateField(
            pqm.question,
            formData[currentSectionIndex][pqm.question.id],
            formData[currentSectionIndex],
            currentSectionIndex,
            allocatedProgram,
            bindingKeyHashMap,
          );
          if (error) {
          newErrors[pqm.question.id] = {
          message: error || "required",
          displayOrder: pqm.displayOrder ?? 0,
          sectionOrder: pqm.programQuestionFormSection?.displayOrder ?? 0,
        };
            isValid = false;
          }
        }
        // }
      }),
    );
    await Promise.all(
      currentSection.needData.map(async (pqm) => {
        // if(formData[currentSectionIndex] && formData[currentSectionIndex][pqm.question.id]) {
        const sectionData = formData[currentSectionIndex];
        if (!sectionData) {
          newErrors[pqm.question.id] = {
          message: "required",
          displayOrder: pqm.displayOrder ?? 0,
          sectionOrder: pqm.programQuestionFormSection?.displayOrder ?? 0,
      };
          isValid = false;
        } else {
          const error = await validateField(
            pqm.question,
            formData[currentSectionIndex][pqm.question.id],
            formData[currentSectionIndex],
            currentSectionIndex,
            allocatedProgram,
            bindingKeyHashMap,
          );
          if (error) {
           newErrors[pqm.question.id] = {
          message: error || "required",
          displayOrder: pqm.displayOrder ?? 0,
        sectionOrder: pqm.programQuestionFormSection?.displayOrder ?? 0,
      };
            isValid = false;
          }
        }
      }),
    );

    await Promise.all(
      (currentSection?.subSection || []).map(async (pqm) => {
        const sectionData = formData[currentSectionIndex];
        if (!sectionData) {
          newErrors[pqm.question.id] = {
          message: "required",
          displayOrder: pqm.displayOrder ?? 0,
         sectionOrder: pqm.programQuestionFormSection?.displayOrder ?? 0,
    };
          isValid = false;
        } else {
          const error = await validateField(
            pqm.question,
            formData[currentSectionIndex][pqm.question.id],
            formData[currentSectionIndex],
            currentSectionIndex,
            allocatedProgram,
            bindingKeyHashMap,
          );
          if (error) {
          newErrors[pqm.question.id] = {
          message: error || "required",
          displayOrder: pqm.displayOrder ?? 0,
          sectionOrder: pqm.programQuestionFormSection?.displayOrder ?? 0,
        };
            isValid = false;
          }
        }
      }),
    );
    // if (currentSectionIndex === 2) {
    //   const pincode = formData[currentSectionIndex][1054];
    //   const gstNumber = formData[currentSectionIndex][1055];
    //   const tdsAmount = formData[currentSectionIndex][1056];
    //   // New cheque number validation
    //   const chequeNumber = formData[currentSectionIndex][504];
    //   // Find pqm for chequeNumber (id 504)
    //   let chequePqm = null;
    //   if (currentSection && currentSection.questions) {
    //     chequePqm = currentSection.questions.find(
    //       (pqm) => pqm.question.id === 504,
    //     );
    //   }
    //   if (chequeNumber && chequePqm) {
    //     const allowedDigits = chequePqm.question.config?.allowedDigits;
    //     const chequeStr = chequeNumber.toString();
    //     if (allowedDigits) {
    //       // allowedDigits is a number, chequeStr should be exactly that many digits
    //       const digitRegex = new RegExp(`^\\d{${allowedDigits}}$`);
    //       if (!digitRegex.test(chequeStr)) {
    //         newErrors[504] = `Must be exactly ${allowedDigits} digits`;
    //         isValid = false;
    //       }
    //     }
    //   }
    //   if (gstNumber && pincode) {
    //     const isValidGST = await validateGSTNumber(pincode, gstNumber);
    //     if (!isValidGST) {
    //       newErrors[1055] =
    //         "GST number does not match the state for the given pincode";
    //       isValid = false;
    //     }
    //   }
    //   const allowedTds = stringToNumber(allocatedProgram?.tdsPercent);
    //   const tdsPercentage =
    //     (Number(tdsAmount) / Number(allocatedProgram?.basePrice)) * 100;
    //   if (allowedTds < tdsPercentage) {
    //     newErrors[1056] = `TDS percent cannot be more than ${allocatedProgram?.tdsPercent}% for this program`;
    //     isValid = false;
    //   }
    // }
    setErrors(newErrors);
    return isValid;
  } catch (error) {
    console.error("Error validating current section:", error);
    // setErrors({ general: "An error occurred while validating the form." });
    return false;
  }
};

export function stringToNumber(value: string | undefined): number {
  return parseFloat(value ?? "") || 0;
}
export const validateField = async (
  question: Question,
  value: any,
  formData: FormResponse,
  currentSectionIndex: number,
  allocatedProgram: any,
  bindingKeyHashMap: { [key: string]: number } | null,
): string | null => {
  const { config } = question;
  
  // Handle multiQuestion validation
  if (question.type === "multiQuestion" && config.isRequired) {
    if (!value || value.toString().trim() === "") {
      return "required";
    }
    
    try {
      const parsedValue = typeof value === "string" ? JSON.parse(value) : value;
      const { questions = [], displayLabelType: parentDisplayType = "slider" } = config || {};
      
      // Check if all sub-questions are filled
      const allRequiredSatisfied = questions.every((q: any) => {
        const mode = q.displayLabelType || parentDisplayType;
        const raw = parsedValue[q.key];
        
        if (mode === "slider") {
          return typeof raw === "number" && Number.isFinite(raw);
        }
        if (mode === "text" || mode === "textarea") {
          if (raw === null || raw === undefined || (typeof raw === "string" && raw.trim() === "")) {
            return false;
          }
          const s = String(raw);
          const minChars = typeof q.minCharacter === "number" ? q.minCharacter : undefined;
          if (minChars != null && s.trim().length < minChars) return false;
          return true;
        }
        return raw !== null && raw !== undefined && raw !== "";
      });
      
      if (!allRequiredSatisfied) {
        return "All fields are required";
      }
    } catch (error) {
      return "Invalid data format";
    }
  }
  
  if (
    config.isRequired &&
    (!value || value.toString().trim() === "") &&
    isDepndencySatisfied(question, value, formData)
  ) {
    return `required`;
  }

  if (question.type == "tel" && value) {
    if (!isValidPhoneNumber(value)) {
      return "enter valid phone number";
    }
  }
  if (question.type === "date" && value) {
    // const dateError = validateDateInput(value, config);
    // if (dateError) {
    //   return dateError;
    // }
    // const currentDate = new Date();
    // const inputDate = new Date(value);
    // const age = currentDate.getFullYear() - inputDate.getFullYear();
    if (!validateDateWithDynamicRange(value, config?.dateTypeValidation ?? "", config?.pastValidation, config?.futureValidation)) {
      return "Registration is allowed for participants more than 13 years of age";
    }
  }
  if (
    value &&
    config.minCharacter &&
    value.toString().length < config.minCharacter
  ) {
    return `min limit: ${config.minCharacter}`;
  }

  if (
    value &&
    config.maxCharacters &&
    value.toString().length > config.maxCharacters
  ) {
    return `max limit: ${config.maxCharacters}`;
  }

  if (
    value &&
    (config.minValue || config.minValue === 0) &&
    question.type === "number" &&
    value < config.minValue
  ) {
    return `min limit: ${config.minValue}`;
  }

  if (
    value &&
    config.maxValue &&
    question.type === "number" &&
    value > config.maxValue
  ) {
    return `max limit: ${config.maxValue}`;
  }

  if (question.type === "email" && value) {
    if (!EMAIL_REGEX.test(value)) {
      return "Please enter a valid email address";
    }
  }

  if (config.validationPattern && value) {
    const rawPattern = config?.validationPattern?.replace(/\\\\/g, "\\");
    const regex = new RegExp(rawPattern);
    if (!regex.test(value)) {
      if(config?.patternErrorMsg){
        return config.patternErrorMsg;
      }
      else{
      return `invalid format`;
      }
    }
  }
  let pincode, gstNumber, tdsAmount;
  if(currentSectionIndex === 2){
    pincode = formData[bindingKeyHashMap?.zip];
    gstNumber = formData[bindingKeyHashMap?.gstNumber];
    tdsAmount = formData[bindingKeyHashMap?.tdsAmount];
  } else if(currentSectionIndex === 1) {
      pincode = formData[bindingKeyHashMap?.proFormaZip];
      gstNumber = formData[bindingKeyHashMap?.proFormaGstNumber];
  }
  if (formData) {
    const chequeNumber = formData[bindingKeyHashMap?.chequeNo];

    if (chequeNumber && question.bindingKey == "chequeNo") {
      const allowedDigits = question.config?.allowedDigits;
      const chequeStr = chequeNumber.toString();
      if (allowedDigits) {
        // allowedDigits is a number, chequeStr should be exactly that many digits
        const digitRegex = new RegExp(`^\\d{${allowedDigits}}$`);
        if (!digitRegex.test(chequeStr)) {
          return `Must be exactly ${allowedDigits} digits`;
        }
      }
    }
    if (gstNumber && pincode && ( question.bindingKey == "gstNumber" || question.bindingKey == "proFormaGstNumber" || question.bindingKey == "proFormaZip")) {
      console.log(gstNumber,pincode, "validity" )
      const isValidGST = await validateGSTNumber(pincode, gstNumber);
      if (!isValidGST) {
        return "GST number does not match the state for the given pincode";
      }
    }
    const allowedTds = stringToNumber(allocatedProgram?.tdsPercent);
    const tdsPercentage = calCulatePercentage(
      Number(tdsAmount),
      Number(allocatedProgram?.basePrice),
    );
    if (allowedTds < tdsPercentage && question.bindingKey == "tdsAmount") {
      return `TDS percent cannot be more than ${allocatedProgram?.tdsPercent}% for this program`;
    }
  }
  return null;
};

export function validateDateInput(
  value: string | Date,
  config: any,
): string | null {
  if (!value) return "Date is required";
  const inputDate = dayjs(value);

  // Static validation: between startDate and endDate
  if (config?.dateTypeValidation === "static") {
    if (
      config.startDate &&
      inputDate.isBefore(dayjs(config.startDate), "day")
    ) {
      return `Date should not be before ${dayjs(config.startDate).format("DD/MM/YYYY")}`;
    }
    if (config.endDate && inputDate.isAfter(dayjs(config.endDate), "day")) {
      return `Date should not be after ${dayjs(config.endDate).format("DD/MM/YYYY")}`;
    }
    return null;
  }
  console.log("config should", config);

  // Dynamic validation: future and past
  const today = dayjs().startOf("day");

  // Past validation (e.g., age should be at least minValue years and at most maxValue years)
  if (config.pastValidation?.enabled) {
    const { unit, minValue, maxValue } = config.pastValidation;
    const diff = today.diff(inputDate, unit);
    if (maxValue != null && diff > maxValue) {
      return `Date should not be more than ${maxValue} ${unit} in the past`;
    }
    if (minValue != null && diff < minValue) {
      return `Date should be at least ${minValue} ${unit} in the past`;
    }
  } else {
    if (inputDate.isBefore(today)) {
      return `Date should not be in the past`;
    }
  }

  // Future validation (e.g., date should not be too far in the future)
  if (config.futureValidation?.enabled) {
    const { unit, minValue, maxValue } = config.futureValidation;
    const diff = inputDate.diff(today, unit);

    if (minValue != null && diff < minValue) {
      return `Date should not exceed ${minValue} ${unit} in the future`;
      // return `Date should be at least ${minValue} ${unit} in the future`;
    }
    if (maxValue != null && diff > maxValue) {
      return `Date should not be more than ${maxValue} ${unit} in the future`;
    }
  } else {
    // If future validation is disabled, date should not be in the future
    if (inputDate.isAfter(today)) {
      return `Date should not be in the future`;
    }
  }

  return null; // Valid
}

const isDepndencySatisfied = (
  question: Question,
  value: any,
  formData: FormResponse,
): boolean => {
  if (
    question?.config?.dependsOn == null ||
    question.config.dependsOn?.length == 0
  )
    return true;

  const dependency = question.config.dependsOn?.some((dep) => {
    if (dep.value == "notNull") {
      return (
        formData[dep.questionId] != null && formData[dep.questionId] !== ""
      );
    }
    return (formData[dep.questionId] == dep.value && !dep.operator) || (Number(formData[dep.questionId]) == Number(dep.value) && dep.operator == "equals");
  });
  return dependency || false;
};
interface RegistrationState {
  programDetails: ProgramDetails | null;
  groupedAnswersData: { [key: number]: GroupedQuestion } | null;
  userStatus: userRegistration | null;
  groupedQuestions: any;
  bindingKeyHashMap: { [key: string]: number } | null; // Map of questionId to bindingKey and value
  QuestionIdHashMap: { [key: number]: string } | null;
  loading: boolean;
  apiError: string[] | null;
  registrationData?: ProgramRegistration | null;
}

const initialState: RegistrationState = {
  programDetails: null,
  groupedAnswersData: null,
  userStatus: null,
  groupedQuestions: null,
  bindingKeyHashMap: null,
  QuestionIdHashMap: null,
  loading: true,
  apiError: null,
  registrationData: null,
};

export const useRegistrationData = (programId: string, seekerId: string) => {
  const [state, setState] = useState<RegistrationState>(initialState);

  const fetchData = useCallback(async () => {
    setState((prev) => ({ ...prev, loading: true, error: null }));

    try {
      // First get registration data to get registrationId
      const registrationResponse = await getCall(
        `user/${seekerId}/registrations?programId=${programId}`,
        undefined,
        false, // user registration status
      );

      const registrationData = registrationResponse?.data?.data?.data;
      const registrationId = registrationData?.[0]?.id;

      // Then fetch all data in parallel including registration questions
      const [programResponse, prefillResponse, registrationAnswersResponse] =
        await Promise.all([
          getCall(`program/${programId}`, undefined, false), // api to render form
          getCall(`user/${seekerId}/prefill`, undefined, false), // prefill data for the user
          registrationId
            ? getCall(
                `registration/${registrationId}/questions`,
                undefined,
                false,
              )
            : Promise.resolve(null), // user entered answers
        ]);
      const prefillData = prefillResponse?.data.data;
      const programData = programResponse?.data?.data;
      // const userData = userResponse?.data?.data;
      const answersData = registrationAnswersResponse?.data.data;
      const groupedAnswersData = registrationId
        ? groupRegistrationQuestions(answersData)
        : {};
      const { grouped, prefilledanswersData, bindingKeyHashMap, QuestionIdHashMap } =
        await getGroupedQuestions(
          programData,
          groupedAnswersData,
          registrationId,
          prefillData,
        );
      const groupedPrefilledAnswersData = mergedPrefilledData(
        prefilledanswersData,
        groupedAnswersData,
      );
      console.log("groupedPrefilledAnswersData", groupedPrefilledAnswersData);
      const userStatus = getProgramDetails(Number(programId), registrationData);

      setState((prev) => ({
        ...prev,
        programDetails: programData,
        groupedAnswersData: groupedPrefilledAnswersData,
        userStatus: userStatus,
        bindingKeyHashMap: programData ? bindingKeyHashMap : null,
        QuestionIdHashMap: programData? QuestionIdHashMap : null,
        // Pass questionsData instead of userData to getGroupedQuestions
        groupedQuestions: programData ? grouped : null,
        registrationData: registrationData[0] ? registrationData[0] : null,
        loading: false,
      }));
    } catch (error) {
      setState((prev) => ({
        ...prev,
        apiError: WARNING_MESSAGES.SOMETHING_WENT_WRONG,
        loading: false,
      }));
    }
  }, [programId, seekerId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    ...state,
    refetch: fetchData,
  };
};

export const mergedPrefilledData = (
  prefilledAnswersData: RegistrationQuestion[] | null,
  groupedAnswersData: { [key: number]: GroupedQuestion } | null,
): { [key: number]: GroupedQuestion } => {
  if (!prefilledAnswersData || !groupedAnswersData)
    return groupedAnswersData || {};
  Object.entries(prefilledAnswersData).forEach(([key, value]) => {
    var sectionId = value.sectionId;
    console.log("sectionIdprefilledAnswersData", sectionId);
    if (sectionId == 4) {
      sectionId = 1;
    }
    if (!groupedAnswersData[sectionId]) {
      groupedAnswersData[sectionId] = {};
      groupedAnswersData[sectionId][value.questionId] = value.answer;
    } else {
      if (!groupedAnswersData[sectionId][value.questionId]) {
        groupedAnswersData[sectionId][value.questionId] = value.answer;
      }
    }
  });
  console.log(
    "sectionIdprefilledAnswersData groupedAnswersData",
    groupedAnswersData,
  );
  return groupedAnswersData;
};

export const groupRegistrationQuestions = (
  questions: RegistrationQuestion[],
): { [key: number]: GroupedQuestion } => {
  const grupedAnswers = questions.reduce(
    (grouped, question) => {
      const { sectionId, questionId, answer } = question;
      var secId = sectionId;
      if (secId == 4) {
        secId = 1; // Adjust sectionId if it is 4
      }
      if (!grouped[secId]) {
        grouped[secId] = {};
      }

      // Add the question answer with questionId as key
      grouped[secId][questionId] = answer;

      return grouped;
    },
    {} as { [key: number]: GroupedQuestion },
  );

  return grupedAnswers;
};

const getGroupedQuestions = async (
  programDetails,
  userDetails,
  registrationId,
  prefillData,
) => {
  if (!programDetails) return {};
  let prefilledanswersData = [];
  const apicallPQMs: ProgramQuestionMap[] = [];
  const bindingKeyHashMap:{ [key: string]: number } = {};
  const QuestionIdHashMap:{ [key: number]: string } = {};
  const grouped = programDetails.programQuestionMaps.reduce(
    (acc, pqm: ProgramQuestionMap) => {
      var sectionId = pqm.programQuestionFormSection.id;
      if (sectionId == 4) {
        sectionId = 1;
      }
      if (!acc[sectionId]) {
        acc[sectionId] = {
          section: pqm.programQuestionFormSection,
          hasData: [],
          needData: [],
          questions: [],
          subSection: [],
        };
      }
      bindingKeyHashMap[pqm.question.bindingKey] = pqm.question.id;
      QuestionIdHashMap[pqm.question.id] = pqm.question.bindingKey
      if (pqm.question.type === "apicall") {
        console.log(
          "API options fetched successfully: console",
          pqm.question.questionOptionMaps,
        );
        // Only fetch if not already loaded
        if (
          !pqm.question.questionOptionMaps ||
          pqm.question.questionOptionMaps.length === 0
        ) {
          apicallPQMs.push(pqm);
        }
      }

      const hasUserData =
        registrationId && userDetails[sectionId] != null
          ? Object.entries(userDetails[sectionId]).filter(([key, value]) => {
              return key == pqm.question.id;
            })
          : [];
      const hasPrefilledData =
        prefillData && prefillData[pqm.question.bindingKey] != null
          ? {
              questionId: pqm.question.id,
              questionLabel: pqm.question.label,
              sectionId:
                pqm.programQuestionFormSection.key == SECTION_KEYS.MAHATRIA
                  ? 1
                  : pqm.programQuestionFormSection.id,
              sectionName: pqm.question.formSection.name,
              answer: prefillData[pqm.question.bindingKey],
            }
          : null;
      if (hasPrefilledData) {
        prefilledanswersData.push(hasPrefilledData);
      }
      if (pqm.programQuestionFormSection.key == SECTION_KEYS.MAHATRIA) {
        acc[sectionId].subSection.push(pqm);
      } else if ((hasUserData.length > 0 || hasPrefilledData) && !(pqm.question.bindingKey === "preference" && pqm.question.type === "draganddrop")) {
        acc[sectionId].hasData.push(pqm);
      } else {
        acc[sectionId].needData.push(pqm);
      }
      if (pqm.programQuestionFormSection.key !=  SECTION_KEYS.MAHATRIA) {
        acc[sectionId].questions.push(pqm);
      }
      return acc;
    },
    {} as {
      [key: number]: {
        section: any;
        hasData: ProgramQuestionMap[];
        needData: ProgramQuestionMap[];
        questions: ProgramQuestionMap[];
        subSection?: ProgramQuestionMap[];
      };
    },
  );
  if(apicallPQMs.length >0){
    await fetchApiOptions(apicallPQMs);
  }
  // for (const pqm of apicallPQMs) {
  //   await fetchApiOptions(pqm);
  // }
  Object.values(grouped).forEach((group) => {
    group.hasData.sort((a, b) => a.displayOrder - b.displayOrder);
    group.needData.sort((a, b) => a.displayOrder - b.displayOrder);
    group.questions.sort((a, b) => a.displayOrder - b.displayOrder);
    group.subSection.sort((a, b) => a.displayOrder - b.displayOrder);
  });
  // Pre-populate form data with existing user data
  const newFormData: FormResponse = {};
  Object.values(grouped).forEach((group) => {
    group.hasData.forEach((pqm) => {
      if (pqm.question.bindingKey && userDetails[pqm.question.bindingKey]) {
        newFormData[pqm.question.id] = userDetails[pqm.question.bindingKey];
      }
    });
  });
  return { grouped, prefilledanswersData, bindingKeyHashMap, QuestionIdHashMap };
};

const fetchApiOptions = async (apicallPQMs: ProgramQuestionMap[]) => {
  // try {
  // You may want to store the endpoint in pqm.question.config or elsewhere
  // For demo, let's assume pqm.question.config.apiEndpoint exists
  const apiEndpoint = apicallPQMs[0].question.config?.apiUrl;
  if (!apiEndpoint) return Promise.resolve();
  await getCall(apiEndpoint, undefined, false)
    .then((response) => {
      if (response?.data?.statusCode === 200) {
        console.log(
          "API options fetched successfully:API options fetched successfully:",
          response.data.data,
        );
        const lookUpData = response.data.data;
        // Map API response to questionOptionMaps format
        for (const pqm of apicallPQMs) {
        pqm.question.questionOptionMaps =
        pqm.question.config?.category ?
        lookUpData[pqm.question.config?.category].map(
          (item: any, idx: number) => {
           return {
              option: {
                id: item.key,
                name: item.value,
              },
            };
          }
        ): [];
        }
      }
    })
    .catch((error) => {
      console.error("Error fetching API options:", error);
    });
};

export const getCurrentSection = (
  setCurrentSectionIndex: (value: any) => void,
  userStatus: userRegistration | null,
  editRegistration: boolean,
  showAdditionalInfo: boolean,
  showSuccess: boolean,
) => {
  if (userStatus?.registrationStatus == CANCELLED){
    return SUCCESS;
  }
  else if(userStatus?.approvals && userStatus?.approvals.length > 0 && (userStatus?.approvals[0]?.approvalStatus == ON_HOLD)) {
    setCurrentSectionIndex(1);
    return "form";
  } 
  else if (
    userStatus?.registrationStatus == null ||
    userStatus?.registrationStatus === undefined ||
    userStatus?.registrationStatus === "draft" ||
    userStatus?.registrationStatus === SAVE_DRAFT ||
    (userStatus.registrationStatus === PENDING_APPROVAL && editRegistration) ||
    (userStatus?.registrationStatus === WAIT_LIST && editRegistration) ||
    (userStatus?.registrationStatus === ON_HOLD && editRegistration) ||
    (userStatus?.approvals &&
      userStatus?.approvals.length > 0 &&
      userStatus?.approvals[0]?.approvalStatus == ON_HOLD) ||
    (userStatus?.registrationStatus === REJECTED && editRegistration)
  ) {
    setCurrentSectionIndex(1);
    return "form";
  } else if(userStatus?.isFreeSeat){
    return SUCCESS;
  } else if (
    // userStatus?.invoiceDetails &&
    // userStatus?.invoiceDetails.length == 0 &&
    !editRegistration &&
    (userStatus?.invoiceDetails.length == 0 ||
      userStatus?.paymentDetails.length == 0 ||
      (userStatus?.registrationStatus == PENDING &&
        (userStatus.paymentDetails[0]?.paymentStatus === ONLINE_PENDING ||
          userStatus.paymentDetails[0]?.paymentStatus === "draft" ||
          userStatus.paymentDetails[0]?.paymentStatus === "failed" ||
          userStatus?.paymentDetails.length == 0)))
  ) {
    setCurrentSectionIndex(2);
    return "form";
  } else if (userStatus?.paymentDetails[0]?.paymentStatus == OFFLINE_PENDING && userStatus?.paymentDetails?.[0]?.editRequests?.[0]?.requestStatus == REQUESTED){
    setCurrentSectionIndex(2);
    return "form";
  }
  else if (
    (userStatus?.registrationStatus == PENDING ||
      userStatus?.registrationStatus == COMPLETED) &&
    userStatus?.travelInfo &&
    userStatus?.travelInfo.length == 0 &&
    showAdditionalInfo &&
    !showSuccess
  ) {
    setCurrentSectionIndex(3);
    return "form";
  }
  return "success";
};

export const getApprovalStatus = (
  userStatus: userRegistration | null,
  editRegistration: boolean,
) => {
  return (
    (userStatus?.registrationStatus === PENDING_APPROVAL &&
      !editRegistration) ||
    userStatus?.registrationStatus === WAIT_LIST ||
    userStatus?.registrationStatus === ON_HOLD ||
    (userStatus?.approvals &&
      userStatus?.approvals.length > 0 &&
      userStatus?.approvals[0]?.approvalStatus == ON_HOLD) ||
    userStatus?.registrationStatus === REJECTED
  );
};

export const getCurrentWaitingHeader = (
  userStatus: userRegistration | null,
  editRegistration: boolean,
): { title: string; description: string } => {
  if (
    userStatus?.registrationStatus === PENDING_APPROVAL &&
    !editRegistration
  ) {
    return {
      title: "Awaiting Mahatria's Approval",
      description:
        "Thanks for completing your registration. Your request has now been placed with  Mahatria",
    };
  }
  if (userStatus?.registrationStatus === WAIT_LIST) {
    return { title: "Waiting List Confirmation", description: "waiting list" };
  }
  if (
    userStatus?.registrationStatus === ON_HOLD ||
    (userStatus?.approvals &&
      userStatus?.approvals.length > 0 &&
      userStatus?.approvals[0]?.approvalStatus == ON_HOLD)
  ) {
    return {
      title: "Registration is yet to be decided",
      description: "Embrace the Divine Experience yet to be decided",
    };
  }
  return {
    title: "Registration is on hold",
    description: "Embrace the Divine Experience on hold",
  };
};

export function mergeArrayOfObjects(
  arr: Array<Record<string, any>>,
): Record<string, any> {
  return arr.reduce((acc, obj) => ({ ...acc, ...obj }), {});
}

export function formatDateRangeToReadable(start: string, end: string): string {
  if (!start || !end) return "";

  const startDate = new Date(start);
  const endDate = new Date(end);

  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const startMonth = startDate.toLocaleString("en-US", { month: "long" });
  const endMonth = endDate.toLocaleString("en-US", { month: "long" });
  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();

  // If both dates are the same
  if (startDay === endDay && startMonth === endMonth && startYear === endYear) {
    return `${startDay} ${startMonth}, ${startYear}`;
  }

  // Same month and year
  if (startDate.getMonth() === endDate.getMonth() && startYear === endYear) {
    return `${startDay} - ${endDay} ${startMonth}, ${startYear}`;
  } else {
    // Different month or year
    return `${startDay} ${startMonth} - ${endDay} ${endMonth}, ${endYear}`;
  }
}

export const getInputValues = (
  programDetails: Program | null,
  formData: any,
  toPrefill?: boolean,
  bindingKeyHashMap?: { [key: string]: number } | null,
) => {
  console.log("programDetails", programDetails);

  const adminGST = programDetails?.gstNumber || "";

  const combinedGst =
    (stringToNumber(programDetails?.cgst) +
      stringToNumber(programDetails?.sgst)) |
    0;
  const igst = stringToNumber(programDetails?.igst) | 0;

  var gstPercentage = combinedGst;
  var tds = 0;

  if (formData && formData[bindingKeyHashMap?.gstNumber]!= undefined && formData[bindingKeyHashMap?.gstNumber] != null) {
    const GSTNumber = formData[bindingKeyHashMap?.gstNumber];
    if (GSTNumber.slice(0, 2) == adminGST.slice(0, 2)) {
      gstPercentage = igst;
    }
  }
  if (formData[bindingKeyHashMap?.tdsAmount] != undefined && formData[bindingKeyHashMap?.tdsAmount] != null) {
    tds = formData[bindingKeyHashMap?.tdsAmount] || 0;
  }
  let gstLabel = "GST @" + gstPercentage + "%";
  const taxFee =
    stringToNumber(programDetails?.basePrice) * (gstPercentage / 100);
  let totalAmount = 0;
  let tdsPercentage = tds;
  let taxTdsPercentage = taxFee * (tds / 100);
  if (programDetails?.tdsApplicability == "base_only") {
    totalAmount = (
      stringToNumber(programDetails?.basePrice) -
      tdsPercentage +
      taxFee
    ).toFixed(2);
  } else {
    totalAmount = (
      stringToNumber(programDetails?.basePrice) -
      taxTdsPercentage +
      taxFee
    ).toFixed(2);
  }

  //  const totalAmount = (stringToNumber(programDetails?.basePrice)+ taxFee - tds).toFixed(2)
  const inputValues = [
    {
      label: "Fee",
      value: `INR ${formatIndianCurrency(Math.round(stringToNumber(programDetails?.basePrice)))}`,
    },
    {
      label: gstLabel,
      value: `INR ${formatIndianCurrency(Math.round(taxFee))}`,
    },
    {
      label: "TDS",
      value: `INR - ${formatIndianCurrency(Math.round(stringToNumber(tds.toString())))}`,
    },
  ];
  const finalValue = {
    label: AMOUNT_TO_BE_PAID,
    value: toPrefill
      ? `${Math.round(totalAmount)}`
      : `INR ${formatIndianCurrency(Math.round(totalAmount))}`,
  };
  return { finalValue, inputValues };
};

export const getAllocatedProgramData = (
  userRegistration: userRegistration | null,
) => {
  console.log("userRegistration", userRegistration);
  if (userRegistration) {
    if (userRegistration?.program.isGroupedProgram) {
      return userRegistration?.allocatedProgram;
    } else if (
      userRegistration?.program?.noOfSession != undefined &&
      userRegistration?.program?.noOfSession != null &&
      userRegistration?.program?.noOfSession > 0
    ) {
      return userRegistration.programSession;
    } else {
      return userRegistration?.program;
    }
  } else return null;
};

export const getSuccessStatus = (
  showSuccess: boolean,
  userStatus: userRegistration | null,
  showAdditionalInfo: boolean,
  editPayment: string | null
) => {
  if (showSuccess && !showAdditionalInfo) {
    return true;
  } else if (
    // showSuccess &&
    userStatus?.registrationStatus === PENDING &&
    userStatus.paymentDetails.length > 0 &&
    ((userStatus.paymentDetails[0]?.paymentStatus === OFFLINE_PENDING && editPayment != "true") ||
      userStatus.paymentDetails[0]?.paymentStatus === ONLINE_COMPLETED ||
      userStatus.paymentDetails[0]?.paymentStatus == OFFLINE_COMPLETED) 
      // &&
    // !showAdditionalInfo
  ) {

    return true;
  } else if(userStatus?.paymentDetails[0]?.paymentStatus === OFFLINE_PENDING && editPayment == "true"){
    return false;
  } 
  else if (
    // showSuccess &&
    userStatus?.registrationStatus === COMPLETED &&
    userStatus?.travelInfo 
    // &&
    // !showAdditionalInfo  
  ) {
    return true;
  }
  else if (
    userStatus?.registrationStatus === COMPLETED &&
    userStatus?.isFreeSeat
  ) {
    return true;
  }
  return false;
};

export const triggerWebhook = async (response: any, paymentType: string) => {
  console.log("Triggering webhook with response:", response);
  const payload = {
    entity: "event_from_ui",
    event: "payment.captured",
    contains: ["payment"],
    payload: {
      payment: {
        entity: {
          id: response?.razorpay_payment_id,
          entity: "payment",
          status: "captured",
          order_id: response?.razorpay_order_id,
          signature: response?.razorpay_signature,
        },
      },
    },
  }
  const failedPayload = {
    entity: "event_from_ui",
    event: "payment.failed",
    contains: ["payment"],
    payload: {
      payment: {
        entity: {
          id: response?.metadata?.payment_id,
          entity: "payment",
          status: "failed",
          order_id: response?.metadata?.order_id,
        },
        response
      },
    },
  }
  const dismissedPayload = {
    entity: "event_from_ui",
    event: "payment.dismissed",
    contains: ["payment"],
    payload: {
      payment: {
        entity: {
          entity: "payment",
          status: "dismissed",
          order_id: response?.orderId,
        },
      },
    },
  }
  
  postCall(
    endPoints.paymentWebhook,
    paymentType === "success" ? payload : (paymentType === "failed" ? failedPayload : dismissedPayload),
    false,
  )
    .then((response) => {
      console.log("Webhook triggered successfully:", response);
      return response;
    })
    .catch((error) => {
      console.error("Error triggering webhook:", error);
      return;
    });
  return null;
};

// /**
//  * Validates a date against dynamic past and future ranges.
//  * @param {string|Date} date - The date to validate (string or Date object)
//  * @param {string} dateValidationType - Should be 'dynamic' to enable this validation
//  * @param {string | null | undefined} pastDateValidation - Max past range in 'YY:MM:DD' format (e.g., '00:00:60') or null/undefined
//  * @param {string | null | undefined} futureDateValidation - Max future range in 'YY:MM:DD' format (e.g., '00:00:00') or null/undefined
//  * @returns {boolean} - true if valid, false otherwise
//  */
export function validateDateWithDynamicRange(
  date: string | Date,
  dateValidationType: string,
  pastDateValidation?: DateValidation | null,
  futureDateValidation?: DateValidation | null,
): boolean {
  if (dateValidationType !== "dynamic") return true;
  const inputDate = typeof date === "string" ? new Date(date) : date;
  if (isNaN(inputDate.getTime())) return false;
  const now = new Date();
  now.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
  
  const inputDateOnly = new Date(inputDate);
  inputDateOnly.setHours(0, 0, 0, 0); // Reset time to start of day
  
  //  Validate past date range if enabled
  if (pastDateValidation?.enabled) {
    const { unit, minValue, maxValue } = pastDateValidation;
    
    //  Check minimum past limit (not more recent than minValue)
    if (minValue !== null && minValue !== undefined) {
      const minPastDate = new Date(now);
      if (unit === "year") {
        minPastDate.setFullYear(now.getFullYear() - minValue);
      } else if (unit === "months") {
        minPastDate.setMonth(now.getMonth() - minValue);
      } else if (unit === "days") {
        minPastDate.setDate(now.getDate() - minValue);
      }
      
      //  Date should be older than minValue years ago
      if (inputDateOnly > minPastDate) {
        console.log(`Date ${inputDateOnly.toDateString()} is too recent. Must be before ${minPastDate.toDateString()}`);
        return false;
      }
    }
    
    //  Check maximum past limit (not older than maxValue)
    if (maxValue !== null && maxValue !== undefined) {
      const maxPastDate = new Date(now);
      if (unit === "year") {
        maxPastDate.setFullYear(now.getFullYear() - maxValue);
      } else if (unit === "months") {
        maxPastDate.setMonth(now.getMonth() - maxValue);
      } else if (unit === "days") {
        maxPastDate.setDate(now.getDate() - maxValue);
      }
      
      //  Date should be newer than maxValue years ago
      if (inputDateOnly < maxPastDate) {
        console.log(`Date ${inputDateOnly.toDateString()} is too old. Must be after ${maxPastDate.toDateString()}`);
        return false;
      }
    }
  }
  
  //  Validate future date range if enabled
  if (futureDateValidation?.enabled) {
    const { unit, minValue, maxValue } = futureDateValidation;
    
    if (minValue !== null && minValue !== undefined) {
      const minFutureDate = new Date(now);
      if (unit === "year") {
        minFutureDate.setFullYear(now.getFullYear() + minValue);
      } else if (unit === "months") {
        minFutureDate.setMonth(now.getMonth() + minValue);
      } else if (unit === "days") {
        minFutureDate.setDate(now.getDate() + minValue);
      }
      
      if (inputDateOnly < minFutureDate) {
        return false;
      }
    }
    
    if (maxValue !== null && maxValue !== undefined) {
      const maxFutureDate = new Date(now);
      if (unit === "year") {
        maxFutureDate.setFullYear(now.getFullYear() + maxValue);
      } else if (unit === "months") {
        maxFutureDate.setMonth(now.getMonth() + maxValue);
      } else if (unit === "days") {
        maxFutureDate.setDate(now.getDate() + maxValue);
      }
      
      if (inputDateOnly > maxFutureDate) {
        return false;
      }
    }
  }
  
  return true;
}


// export async function validateGSTNumber(
//   pincode: string,
//   gstNumber: string,
// ): Promise<boolean> {
//   // console.log('validateGSTNumber', pincode, gstNumber);
//   try {
//     // Fetch state and state code for the given pincode
//     const response = await axios.get(
//       `https://api.postalpincode.in/pincode/${pincode}`,
//     );
//     // console.log('response', response.data);
//     const stateName = response.data?.[0]?.PostOffice?.[0]?.State;

//     const gstCodeOfState = stateGstCodes.find(
//       (item: any) => item?.stateName === stateName,
//     );

//     // Extract the state code from the GST number
//     const stateCode = gstCodeOfState ? gstCodeOfState?.code : "";

//     // console.log(
//     //   (gstCodeOfState && gstNumber?.startsWith(stateCode)) || false,
//     //   'TEST VALID GST'
//     // );

//     // Check if the GST number starts with the state code
//     return gstCodeOfState ? gstNumber?.startsWith(stateCode) : false;
//   } catch (error) {
//     // console.error('Error fetching pincode details:', error);
//     return false;
//   }
// }

export async function validateGSTNumber(
  pincode: string,
  gstNumber: string,
): Promise<boolean> {
  // Try using the Postal Pincode API first
  const isValidUsingPostalAPI = await validateUsingPostalAPI(
    pincode,
    gstNumber,
  );

  if (isValidUsingPostalAPI !== null) {
    return isValidUsingPostalAPI;
  }

  // Fallback to Google Geocoding API
  return await validateUsingGoogleAPI(pincode, gstNumber);
}

async function validateUsingPostalAPI(
  pincode: string,
  gstNumber: string,
): Promise<boolean | null> {
  try {
    const response = await axios.get(
      `https://api.postalpincode.in/pincode/${pincode}`,
    );

    const data = response.data?.[0];

    if (data?.Status === "Error" || !data?.PostOffice) {
      return null; // fallback to next API
    }

    const stateName = data.PostOffice?.[0]?.State;

    const gstCodeOfState = stateGstCodes.find(
      (item: any) => item?.stateName === stateName,
    );

    const stateCode = gstCodeOfState?.code ?? "";
    return gstCodeOfState ? gstNumber.startsWith(stateCode) : false;
  } catch (error) {
    return null; // fallback
  }
}

async function validateUsingGoogleAPI(
  pincode: string,
  gstNumber: string,
): Promise<boolean> {
  try {
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&components=country:IN&key=${process.env.REACT_APP_GEOAPIFY_API_KEY}`,
    );

    const addressComponents =
      response.data?.results?.[0]?.address_components ?? [];

    const stateComponent = addressComponents.find((component: any) =>
      component.types.includes("administrative_area_level_1"),
    );

    const stateShortName = stateComponent?.short_name;
    const stateLongName = stateComponent?.long_name;

    const gstCodeOfState = stateGstCodes.find(
      (item: any) =>
        item.state === stateShortName || item.stateName === stateLongName,
    );

    const stateCode = gstCodeOfState?.code ?? "";
    return gstCodeOfState ? gstNumber.startsWith(stateCode) : false;
  } catch (error) {
    return false;
  }
}
// export function isRegistrationsOpen (programDetails: ProgramDetails | null): boolean {
//   if (!programDetails) return false;
//   const currentDate = new Date();
//   const startDate = new Date(programDetails?.registrationStartsAt);
//   const endDate = new Date(programDetails?.registrationEndsAt);
//   // Check if the current date is within the registration period
//   return currentDate >= startDate && currentDate <= endDate;
// }

export const getAllocatedProgamPrice = (
  userRegistration: userRegistration | null,
) => {
  if (userRegistration) {
    if (userRegistration?.program.isGroupedProgram) {
      console.log(
        "userRegistration?.allocatedProgram?.allocatedProgram",
        userRegistration?.allocatedProgram?.basePrice,
      );
      return {
        price: stringToNumber(userRegistration?.allocatedProgram?.basePrice),
        program: userRegistration?.allocatedProgram,
      };
    } else if (
      userRegistration?.program?.noOfSession != undefined &&
      userRegistration?.program?.noOfSession != null &&
      userRegistration?.program?.noOfSession > 0
    ) {
      console.log(
        "userRegistration?.allocatedProgram?.programSession",
        userRegistration?.allocatedProgram?.basePrice,
      );

      return {
        price: stringToNumber(userRegistration.programSession?.basePrice),
        program: userRegistration.programSession,
      };
    } else {
      console.log(
        "userRegistration?.allocatedProgram?.basePrice",
        userRegistration?.allocatedProgram?.basePrice,
      );
      return {
        price: stringToNumber(userRegistration?.program?.basePrice),
        program: userRegistration?.program,
      };
    }
  } else return null;
};

// Add the function to get registration status
export const getRegistrationStatus = async (
  registrationId: number,
): Promise<RegistrationStatus> => {
  try {
    const response = await getCall(
      `registration/${registrationId}/statuses`,
      undefined,
      false,
    );
    if (response?.data?.statusCode === 200) {
      return response.data.data;
    }
    throw new Error("Failed to get registration status");
  } catch (error) {
    console.error("Error getting registration status:", error);
    throw error;
  }
};

export const getPrice = (userStatus: any, formData: any, option: string, bindingKeyHashMap: { [key: string]: number } | null) => {
  if (option != "Cash") {
    return true;
  }
  const result = getAllocatedProgamPrice(userStatus);
  const program = result?.program;
  const { finalValue, inputValues } = getInputValues(
    program,
    formData || {},
    true,
    bindingKeyHashMap,
  );
  return stringToNumber(finalValue?.value) <= 200000;
};
// File validation constants
export const MAX_FILE_SIZE_MB = 3;
export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

// UI Text constants
export const UI_TEXT = {
  UPLOAD_PROMPT: 'upload latest photo here',
  UPLOAD_INSTRUCTION_1: 'Please upload your image in',
  UPLOAD_INSTRUCTION_2: `JPG, JPEG, PNG (max size: ${MAX_FILE_SIZE_MB} MB).`,
  OR_DIVIDER: 'or',
  CAPTURE_PROMPT: 'capture now',
  HEADER_TITLE: 'How do you want to upload your profile picture?',
  DOS_LABEL: "Do's:",
  DOS_INSTRUCTION: 'Front-facing view, neutral background, no filters, hats, or sunglasses.',
  DONTS_LABEL: "Don'ts:",
  DONTS_INSTRUCTION: 'Group photos or selfies with others, edited or filtered images, side profiles or tilted angles.',
  RETAKE_TEXT: 'Retake',
  CAPTURE_TEXT: 'Capture',
  DISCARD_BUTTON: 'discard',
  SUBMIT_BUTTON: 'submit'
};

// Toast message constants
export const TOAST_MESSAGES = {
  INVALID_FILE_TYPE: {
    title: 'Invalid File Type',
    message: 'Please select a valid image file (PNG, JPEG, or JPG only).'
  },
  FILE_SIZE_TOO_LARGE: {
    title: 'File Size Too Large',
    message: (fileSize: string) => `File size (${fileSize}) exceeds the ${MAX_FILE_SIZE_MB}MB limit. Please select a smaller image.`
  },
  CAMERA_ACCESS_ERROR: {
    title: 'Camera Access Error',
    message: 'Unable to access camera. Please check permissions.'
  },
  IMAGE_SIZE_TOO_LARGE: {
    title: 'Image Size Too Large',
    message: (imageSize: string) => `Captured image size (${imageSize}) exceeds the ${MAX_FILE_SIZE_MB}MB limit. Please try again with better lighting or move closer.`
  }
};
export const PAYMENT_CONTENT = {
  METHOD_SELECTION: "You are choosing 'Online' payment method.",
  REDIRECT_INFO: "On clicking submit, you will be redirected to Razorpay payment gateway, which enables you to make payment using",
  PAYMENT_OPTIONS: {
    CARDS: "Cards",
    INTERNET_BANKING: "internet banking", 
    UPI: "UPI",
    WALLETS: "Wallets"
  },
  FORMATTED_PAYMENT_TEXT: "Cards, internet banking, UPI",
  FORMATTED_WALLET_TEXT: "Wallets."
};

export const UI_CONSTANTS = {
  RAZORPAY_ALT_TEXT: "Razorpay payment gateway"
};


export const isDependentCleared = (needQuestions: any, bindingKeyHashMap: any, formData: any)=>{
  console.log("needQuestions", needQuestions)
  const dependentsQuestion = [];
  needQuestions.map((item:any)=> {
     const question = item?.question?.config?.dependsOn?.filter((depQuestion: any)=>{
        if(depQuestion.value === formData[bindingKeyHashMap[depQuestion.questionBindingKey]]){
          return true;
        }
    })

    console.log("The question 1needQuestions", question);
    if(question?.length == 0){
      dependentsQuestion.push(item);
    }
  })

  if((needQuestions?.length - dependentsQuestion?.length) > 0){
    return true;
  }
  return false;
}


export const checkRegistrationWindowStatusOfEntrainment = async (
  programKey: string = "PT_ENTRAINMENT",
): Promise<boolean> => {
  try {
    const response = await getCall(
      endPoints.getProgramEndPoint({
        status: "published",
        programKey: programKey,
      }),
      undefined,
      false,
    );

    if (response?.status === 200 && response?.data?.data?.data) {
      const programs = response.data.data.data;

      // Find the program that exactly matches the programKey
      const targetProgram = programs.find(
        (program: any) => program.program === programKey,
      );

      if (targetProgram && targetProgram.registrationWindowStatus) {
        return targetProgram.registrationWindowStatus === "OPENED";
      }
    }

    return false;
  } catch (error) {
    console.error("Error checking registration window status:", error);
    return false;
  }
};